function loadAppSettings(global) { 
  const appSettings = {};
  // Include Logic To Find window variables To Make Available To the App
  const mscSettings = global.WVUS_MSC || {
    cancel_reasons_to_ignore: "",
    enable_archive_child_experience: false,
    rfl_group: {}
  };

  const envirSettings = global.WVUS_ENV_VARS || {
    urls: {
      core: "https://qa.worldvision.org",
      core2: "https://www.worldvision.org/core2",
      donate: "https://donate.worldvision.org",
      messages: "https://messages.worldvision.org",
      mywv: "https://myqa.worldvision.org"
    }
  };

  // Evnrivorment Variables
  appSettings.env = envirSettings;
  appSettings.currentEnv = envirSettings.current_env;
  appSettings.urls = envirSettings.urls;

  // MSC Variables
  appSettings.msc = mscSettings;
  appSettings.enableArchiveChild = !!mscSettings.enable_archive_child_experience;
  appSettings.cancelReasonsToIgnore = mscSettings.cancel_reasons_to_ignore &&  
    mscSettings.cancel_reasons_to_ignore.toLowerCase().split(",") || 
    [];
  appSettings.rflGroups = mscSettings.rfl_group || {
    "project-closure": {
      "title": "",
      "text": ""
    }

  };
  appSettings.rflParamName = "rflgrouping";

  // Silhouette Images
  appSettings.silhouette = {
    "Male": "https://wvusstatic.com/images/childsilhouette_boy-blue.png",
    "Female": "https://wvusstatic.com/images/childsilhouette_girl-blue.png"
  };

  appSettings.countryImage = {
    path: "https://wvusstatic.com/2019/country-images",
    fallback: "fallback.jpg"
  };

  appSettings.childPrivacyUrl = `${envirSettings.urls.core}/my/modal/childprivacy`;

  appSettings.emailMyChildUrl = `${envirSettings.urls.mywv}/email-child/new-message`;

  // Error Messages 
  appSettings.errorMessages = {
    generalError: ""
  };

  appSettings.replaceTokens = {
    "childname": "{child_first_name}",
    "hisher": "{his_her}",
    "hishers": "{his_hers}",
    "himher": "{him_her}",
    "heshe": "{he_she}"
  };

  appSettings.featuredVideoMap = {
    "project-closure": { 
      "contentTypeCode": "YFV",
      "description": "Celebration Video"
    },
    "phase-out": { 
      "contentTypeCode": "YFV",
      "description": "Celebration Video"
    }
  };

  return appSettings;
}

export default loadAppSettings(typeof window !== "undefined" ? window : {});